<template>
    <div id="caller-wrapper">
        <!--[start] Incoming Call -->
        <div class="container">

            <audio id="incomingCallAudio">
                <source src="" type="audio/mp3">
            </audio>

            <!--
            <b-modal id="modal-call-alert" :title="'A tutor is inviting you for a call'" content-class="esi-modal" 
            :header-bg-variant="headerBgVariant" no-close-on-esc no-close-on-backdrop hide-header-close>
            -->

            <b-modal id="modal-call-alert" content-class="esi-modal" :header-bg-variant="headerBgVariant"
                no-close-on-esc no-close-on-backdrop hide-header-close>


                <!-- Custom header slot -->
                <template #modal-title>
                    <div class="d-flex align-items-center">
                        <img :src="'images/myroom.png'" class="modal-mypage-logo mr-2" alt="Room Logo" />
                        <!--<span>A tutor is inviting you for a call</span>-->
                    </div>
                </template>

                <div class="row text-center" v-if="this.callReservation !== null">
                    <div class="col-12 text-center">
                        <div class="alert alert-primary" role="alert">
                            Please accept a lesson invitation from <span v-show="this.caller.nickname">({{
                                this.caller.nickname
                                }})</span>
                            <!--  <div class="fullname">{{ this.caller.firstname + " " + this.caller.lastname }}</div>-->
                            <!-- Email: {{ this.caller.email }}  </div>-->
                        </div>
                        <img :src="this.caller.image" class="rounded-circle " width="150px">
                    </div>
                </div>

                <template #modal-footer>
                    <div class="container text-center">
                        <p class="text-muted small mb-2">Set camera and microphone before joining</p>
                        <div class="incoming-call-media-controls mb-3">
                            <b-button
                                type="button"
                                :variant="joinWithVideo ? 'outline-secondary' : 'danger'"
                                class="mx-1 mb-2"
                                @click="toggleJoinVideo"
                            >
                                <b-icon :icon="joinWithVideo ? 'camera-video-fill' : 'camera-video-off-fill'"></b-icon>
                                {{ joinWithVideo ? 'Camera on' : 'Camera off' }}
                            </b-button>
                            <b-button
                                type="button"
                                :variant="joinWithMic ? 'outline-secondary' : 'danger'"
                                class="mx-1 mb-2"
                                @click="toggleJoinMic"
                            >
                                <b-icon :icon="joinWithMic ? 'mic-fill' : 'mic-mute-fill'"></b-icon>
                                {{ joinWithMic ? 'Mic on' : 'Mic muted' }}
                            </b-button>
                        </div>
                        <b-button variant="success" @click="acceptCall">
                            <b-icon icon="telephone-inbound" animation="throb" font-scale="1"></b-icon>
                            <span class="pb-3" animation="throb">Enter Lesson</span>
                        </b-button>
                    </div>
                </template>

            </b-modal>


        </div>
        <!--[end]-->


        <!-- SELECT LESSON -->
        <div id="select-lesson-container" class="container-fluid">

            <b-modal id="modalSelectLesson" @show="getLessonsList" title="Select a Lesson" size="xl"
                header-bg-variant="primary" header-text-variant="white" hide-footer no-close-on-esc>

                <div v-if="hasSelected == true">
                    <div class="alert alert-success" role="alert">
                        You selected a new lesson. (レッスン教材の選択が完了しました）
                    </div>
                </div>

                <div v-if="hasSelected == false">
                    <div class="container" v-if="currentSelectedFolder !== null">
                        <div class="card mb-3">
                            <h5 class="card-header bg-secondary text-white">Current Lesson Selected </h5>
                            <div class="card-body bg-light">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="card-title">{{ currentSelectedFolder.folder_name }}</div>
                                        <p class="card-text">{{ currentSelectedFolder.folder_description }}</p>
                                    </div>
                                    <div class="col-12">
                                        <div class="row" v-if="currentSelectedFiles != null">
                                            <div class="col-2" v-for="(file, fileIndex) in currentSelectedFiles"
                                                :key="'image-' + fileIndex">
                                                <img :src="getBaseURL(file.path)" class="img-fluid cursor-pointer"
                                                    @click.prevent="imageViewer(getBaseURL(file.path))" />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="mt-3 text-center">
                        <div class="text-danger">Please select a folder</div>
                    </div>

                    <div id="ui-search-folders" class="container">

                        <div id="slideSelection" v-if="isSearching == false">

                            <div id="lesson-instructions" class="row mb-2">
                                <div class="col-7">
                                    <h5 class="text-maroon">
                                        Please select a Lesson
                                    </h5>
                                    <div class="font-weight-bold small float-left">前回のレッスンコースを継続する場合、入力は必要ありません。</div>
                                </div>
                                <div class="col-5">
                                    <div class="float-right">
                                        <b-button variant="primary" @click="openSearchUI()">
                                            <b-icon icon="search" aria-hidden="true"></b-icon>
                                        </b-button>

                                        <b-button variant="primary" @click="selectCategory(parentID)"
                                            v-if="parentID !== null">
                                            <b-icon icon="arrow-return-left" aria-hidden="true"></b-icon>
                                        </b-button>
                                    </div>
                                </div>
                            </div>

                            <div v-if="currentFolder !== null">
                                <!--[start] Lesson Card -->
                                <div class="card">



                                    <!--[start] Preview Images -->
                                    <!--
                                    <div class="card-header">                                   
                                        <b-carousel id="carousel-files" v-model="slide" class="cursor-pointer"
                                            :interval="4000" controls indicators background="#ababab" style="text-shadow: 1px 1px 2px #333;"
                                            @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
                                            <b-carousel-slide v-for="file in files" :key="'file_'+ file.id" >
                                                <template #img>
                                                    <div class="text-center " style="height:150px">
                                                        <img :src="getBaseURL(file.path)" class="img-fluid  cursor-pointer" height="auto" @click="imageViewer(getBaseURL(file.path))"/>                                        
                                                    </div>
                                                </template>
                                            </b-carousel-slide>
                                        </b-carousel>                                    
                                    </div>
                                    -->
                                    <!--[end] Preview Images -->

                                    <!-- [start] Lesson Information  -->
                                    <div class="card px-2">
                                        <div class="row">
                                            <div class="col-6">
                                                <div id="lesson-information" class="py-3">
                                                    <h4 class="card-title h3">{{ currentFolder.folder_name }}</h4>
                                                    <p class="card-text small text-secondary">{{
                                                        currentFolder.folder_description }}</p>

                                                    <div id="button-lesson-select" v-if="folderCategories.length > 0">
                                                        <div class="alert alert-primary" role="alert">
                                                            <span class="text-success">Please select a category</span>
                                                        </div>
                                                    </div>

                                                    <div v-else id="more-lessons-container" class="text-secondary">
                                                        <div class="alert alert-primary" role="alert">
                                                            <span class="text-success">Please select a lesson</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-6">

                                                <div id="lessons-container" class="accordion my-4" v-if="rows >= 1">
                                                    <b-table id="lesson-table" ref="lesson-table" :items="lessons"
                                                        :fields="fields" :per-page="perPage" :current-page="currentPage"
                                                        :striped="false" :hover="true" borderless :outlined="false"
                                                        :class="'no-padding'">


                                                        <template #cell(actions)="row">

                                                            <b-card no-body>
                                                                <b-card-header header-tag="header" class="p-0"
                                                                    role="tab">
                                                                    <b-button-group block class="w-100">
                                                                        <b-button block variant="primary"
                                                                            @click="getLessonImages(row.index, row.item.id)">
                                                                            {{ row.item.folder_name }}
                                                                        </b-button>
                                                                        <b-button variant="success" size="sm"
                                                                            class="w-25"
                                                                            @click.prevent="selectNewLesson(row.item.id)">
                                                                            <div class="small text-center"> Select
                                                                                Lesson</div>
                                                                        </b-button>
                                                                    </b-button-group>
                                                                </b-card-header>
                                                                <b-collapse v-model="isCollapsed[row.index]"
                                                                    id="my-collapse-id">
                                                                    <b-card-body v-if="folder_images[row.index]">
                                                                        <div class="row">
                                                                            <div class="col-4"
                                                                                v-for="(images, imageIndex) in folder_images[row.index]"
                                                                                :key="'folder_images_' + row.index + '_' + imageIndex">
                                                                                <img class="img-fluid cursor-pointer"
                                                                                    :src="getBaseURL(images.path)"
                                                                                    @click.prevent="imageViewer(getBaseURL(images.path))">
                                                                            </div>
                                                                        </div>
                                                                    </b-card-body>
                                                                </b-collapse>
                                                            </b-card>


                                                        </template>
                                                    </b-table>




                                                    <div class="mt-3">
                                                        <!--<b-pagination v-model="currentPage" :total-rows="rows" :input="openPage('page-' +currentPage)" :per-page="perPage" :limit="10"></b-pagination>-->
                                                        <b-pagination v-model="currentPage" :total-rows="rows"
                                                            :per-page="perPage" :limit="5" @input="clearFolderImages"
                                                            aria-controls="lesson-listings">
                                                        </b-pagination>
                                                    </div>

                                                    <!--
                                                    <div class="col-12 cursor-pointer" v-for="lesson in lessons" :key="'lesson_'+lesson.id" @click="selectNewLesson(lesson.id)">
                                                        <div class="card mb-3 border-primary cursor-pointer">
                                                            <div class="card-header bg-primary">
                                                                <span class="text-white">
                                                                    {{ lesson.folder_name }}
                                                                </span>
                                                            </div>
                                                            <div class="card-body card-body-minimum">
                                                                <p class="card-text small">
                                                                    {{ lesson.folder_description }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    -->

                                                </div>

                                                <!--
                                                <div v-else>
                                                    <div class="text-center my-4">
                                                        <span class="small text-maroon">No Lessons for this category</span>
                                                    </div>
                                                </div>-->
                                            </div>

                                        </div>

                                    </div>
                                    <!-- [end] Lesson Information  -->
                                </div>
                                <!--[end] Lesson Card-->
                            </div>



                            <!-- Categories -->
                            <div class="mt-3" v-if="folderCategories.length >= 1">



                                <fieldset class="border p-2">

                                    <legend class="w-auto text-primary">
                                        <span v-if="parentID !== null"> Related Categories</span>
                                        <span v-else>Lesson Categories</span>
                                    </legend>

                                    <div id="folder-categories" class="row">
                                        <div class="col-3 cursor-pointer" v-for="category in folderCategories"
                                            :key="'category_' + category.id" @click="selectCategory(category.id)">
                                            <div class="card mb-3 border-primary cursor-pointer">
                                                <div class="card-header bg-primary">
                                                    <span class="text-white">
                                                        {{ category.folder_name }}
                                                    </span>
                                                </div>
                                                <div class="card-body card-body-minimum">
                                                    {{ "subcategory counter" + category.subcategoryCounter }}

                                                    <p class="card-text small">
                                                        {{ category.folder_description }}
                                                    </p>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <!--[end] Categories -->

                        </div>

                        <div v-else-if="isSearching == true">

                            <div id="lesson-instructions" class="row mb-2">
                                <div class="col-4">
                                    <h5 class="text-maroon">Search </h5>
                                </div>
                                <div class="col-8">
                                    <div class="float-right">
                                        <b-button variant="primary" @click="closeSearchUI()">
                                            <b-icon icon="x" aria-hidden="true"></b-icon>
                                        </b-button>
                                    </div>
                                </div>
                            </div>

                            <div role="group" class="input-group">
                                <!--[start] Seach Icon-->
                                <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <b-icon icon="search" aria-hidden="true"></b-icon>
                                    </div>
                                </div>
                                <!--[end] Search Icon -->
                                <!--[start] Seach Keyword -->
                                <input id="bv-icons-table-search" type="search" v-model="searchKeyword"
                                    @blur="handleSearch()" @keyup="handleSearch()" @change="handleSearch()"
                                    @clear:append="handleSearch()" @click="handleSearch()" autocomplete="off"
                                    aria-controls="bv-icons-table-result" class="form-control">
                                <!--[end] Search Keyword-->
                            </div>

                            <!--[start] search results -->

                            <fieldset class="border p-2 mt-2">

                                <legend class="w-auto text-primary">
                                    <span>Search Results</span>
                                </legend>

                                <div class="container">
                                    <div class="row mt-1" v-if="searchResults.length >= 1">
                                        <div class="col-3 cursor-pointer" v-for="category in searchResults"
                                            :key="'search_' + category.id" @click="selectCategory(category.id)">
                                            <div class="card mb-3 border-primary">
                                                <div class="card-header bg-primary">
                                                    <span class="text-white">
                                                        {{ category.folder_name }}
                                                    </span>
                                                </div>
                                                <div class="card-body card-body-minimum">
                                                    <p class="card-text small">
                                                        {{ category.folder_description }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="col-12 text-center">
                                        <div class="py-4">
                                            <span class="text-danger small">No results found</span>
                                        </div>
                                    </div>
                                </div>

                            </fieldset>

                            <!--[end] -->

                        </div>
                    </div>
                </div>
            </b-modal>
        </div>




        <div id="image-viewer-container" class="container-fluid">
            <b-modal id="modalImageViewer" size="xl" title="Image Preview" ok-only>
                <div v-if="imageURL !== null">
                    <img :src="imageURL" class="img-fluid">
                </div>
            </b-modal>
        </div>
    </div>


</template>

<script>

import io from "socket.io-client";
import Moment from "moment-timezone";
import MemberLessonSliderComponent from "./MemberLessonSliderComponent.vue";


export default {
    name: "memberCallerComponent",
    components: {
        MemberLessonSliderComponent
    },
    props:
    {
        csrf_token: String,
        api_token: String,
        user_image: String,
        isBroadcaster: {
            type: [Boolean],
            required: true
        },
        userInfo: {
            type: [Object, String, Number],
            required: false,
            default: () => ({}),
        },
        canvasServer: {
            type: [String],
            required: true
        },
        memberInfo: {
            type: [Object, String],
            required: false,
            default: () => ({}),
        },
    },
    data() {
        return {


            incomingCallAudioInterval: null,
            joinWithVideo: true,
            joinWithMic: true,

            isModalMaximized: false,

            headerBgVariant: 'lightblue',


            user: null,
            users: null,
            tutor: null,
            reservation: null,

            now: null,
            currentTime: null,
            lessonStartTime: null,
            lessonEndTime: null,

            //Selected lesson Options
            selectedOption: null,

            //Model lesson Value
            lessonSelected: null,
            lessonSelectedFolderID: null,

            //Lesson Options
            lessonOptions: [],

            //caller
            caller: null,
            recipient: null,
            callReservation: null,

            //loader
            sliderLoaded: false,
            channelid: null,


            //Member Reservation
            lessonReservationData: null,




            isSearching: false,
            searchTimeout: null,
            searchKeyword: null,
            searchResults: [],

            //Carousel sliders
            slide: 0,
            sliding: null,

            //Lesson Selected ID
            selectedLessonID: null,

            //[list]
            currentFolderID: null,
            currentFolder: null,
            parentID: null,

            folderCategories: [],
            lessons: [],
            files: [],
            folder: null,
            imageURL: null,

            //client ID
            lessonID: null,
            userID: null,


            //Model lesson Value
            lessonSelected: null,
            lessonSelectedFolderID: null,

            //Current Selected (Lesson)
            currentMember: null,
            myReservation: null,

            currentSelectedFolder: null,
            currentSelectedFiles: [],

            //Lesson list
            hasSelected: false,
            selectSuccessMessage: null,

            currentPage: null,
            rows: 0,
            perPage: 5,
            fields: [
                //{ key: 'folder_name', label: 'Lesson', sortable: true, sortDirection: 'desc' },
                { key: 'actions', label: 'Actions' }
            ],


            //accordion images
            folder_images: [],
            isCollapsed: [],
        }
    },
    mounted() {
        window.memberCallerComponent = this;

        const serverUrl = this.resolveCanvasServer();
        console.log('member caller socket:', serverUrl);
        if (!serverUrl) {
            console.error('member caller: no canvas server URL');
        }

        this.socket = io(serverUrl, {
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionAttempts: 10,
            reconnectionDelay: 1000,
        });

        this.socket.on('connect', () => {
            console.log('member caller connected:', this.socket.id);
            this.registerMemberOnSocket();
        });

        this.socket.on('connect_error', (err) => {
            console.error('member caller connect_error:', err.message || err);
        });

        this.socket.on('update_user_list', (users) => {
            this.updateUserList(users);
        });

        this.socket.on('user_disconnected', (tutor) => {
            if (!this.caller) {
                return;
            }
            const callerId = this.caller.userid || this.caller.userId;
            if (String(callerId) === String(tutor.userId || tutor.userid)) {
                this.cancelCall();
                this.stopIncomingCallAudio();
            }
        });

        this.socket.on('CALL_USER', (userData) => {
            this.handleIncomingCall(userData);
        });

        window.addEventListener('member-incoming-call', (event) => {
            if (event.detail) {
                this.handleIncomingCall(event.detail);
            }
        });

        this.socket.on("ACCEPT_CALL", (data) => {
            console.log("ACCEPT_CALL", data);

            if (this.user.userid == data.tutorData.userid) {
                this.$bvModal.hide('modal-call-alert');
                this.caller = data.caller;
                this.recipient = data.recipient;
                this.callReservation = data.reservationData;
            }
        });





        this.socket.on("START_SLIDER", (data) => {

            if (this.user.userid == data.recipient.userid) {
                this.lessonReservationData = data.reservationData;
                this.$bvModal.hide('modal-call-teacher');
                this.$bvModal.hide('modal-call-member');
                this.$bvModal.hide('modal-call-alert');
                //this.openSelfWindow(data.channelid);       

            } else if (this.user.userid == data.caller.userid) {

                this.lessonReservationData = data.reservationData;
                this.$bvModal.hide('modal-call-teacher');
                this.$bvModal.hide('modal-call-member');
                this.$bvModal.hide('modal-call-alert');
                //this.openSelfWindow(data.channelid);  

            }

        });
    },
    methods: {
        normalizeUserInfo() {
            let info = this.userInfo;
            if (typeof info === 'string') {
                try {
                    info = JSON.parse(info);
                } catch (e) {
                    info = {};
                }
            }
            return info && typeof info === 'object' ? info : {};
        },
        normalizeMemberInfo() {
            let info = this.memberInfo;
            if (typeof info === 'string') {
                try {
                    info = JSON.parse(info);
                } catch (e) {
                    info = {};
                }
            }
            return info && typeof info === 'object' ? info : {};
        },
        resolveMemberUserId() {
            if (window.__MEMBER_CALL_CONFIG && window.__MEMBER_CALL_CONFIG.userId) {
                return String(window.__MEMBER_CALL_CONFIG.userId);
            }
            const userInfo = this.normalizeUserInfo();
            const memberInfo = this.normalizeMemberInfo();
            const meta = document.querySelector('meta[name="member-user-id"]');
            const metaId = meta && meta.getAttribute('content');
            return String(userInfo.id || memberInfo.user_id || metaId || '');
        },
        resolveCanvasServer() {
            if (window.__MEMBER_CALL_CONFIG && window.__MEMBER_CALL_CONFIG.canvasServer) {
                return String(window.__MEMBER_CALL_CONFIG.canvasServer).replace(/\/$/, '');
            }
            return String(this.canvasServer || '').replace(/\/$/, '');
        },
        registerMemberOnSocket() {
            if (!this.socket || !this.socket.connected) {
                return;
            }

            const userId = this.resolveMemberUserId();
            if (!userId) {
                console.error('member caller REGISTER failed — no user id', this.userInfo, this.memberInfo);
                return;
            }

            const userInfo = this.normalizeUserInfo();
            const memberInfo = this.normalizeMemberInfo();

            this.user = {
                channelid: null,
                public: true,
                userid: userId,
                username: userInfo.username || '',
                nickname: userInfo.nickname || memberInfo.nickname || userInfo.firstname || '',
                firstname: userInfo.firstname || '',
                lastname: userInfo.lastname || '',
                image: this.$props.user_image,
                type: String(userInfo.user_type || 'MEMBER').toUpperCase(),
                status: 'ONLINE',
            };

            this.socket.emit('REGISTER', this.user);
            console.log('member caller REGISTER', userId, 'socket', this.socket.id, '— invites only arrive for this user id');
        },
        callTargetsThisMember(userData) {
            const myId = this.resolveMemberUserId();
            if (!myId) {
                return false;
            }
            const ids = [];
            if (userData.recipient) {
                const rid = userData.recipient.userid || userData.recipient.userId;
                if (rid != null && rid !== '') {
                    ids.push(String(rid));
                }
            }
            const reservation = userData.reservationData || userData.reservation;
            if (reservation) {
                if (reservation.member_user_id != null && reservation.member_user_id !== '') {
                    ids.push(String(reservation.member_user_id));
                }
                if (reservation.member_id != null && reservation.member_id !== '') {
                    ids.push(String(reservation.member_id));
                }
            }
            return ids.some((id) => id === myId);
        },
        handleIncomingCall(userData) {
            console.log('CALL_USER received on mypage', userData);

            const myId = this.resolveMemberUserId();
            const recipientId = userData.recipient && (userData.recipient.userid || userData.recipient.userId);
            const memberUserId = userData.reservationData && userData.reservationData.member_user_id;

            if (!this.callTargetsThisMember(userData)) {
                console.warn(
                    'CALL_USER ignored — you are logged in as user',
                    myId,
                    'but this lesson call is for user',
                    memberUserId || recipientId,
                    '(log in as the student on the reservation to see the invite)'
                );
                return;
            }

            const scheduleId = (userData.reservationData && userData.reservationData.schedule_id)
                || userData.channelid
                || userData.roomId;
            if (!scheduleId) {
                console.warn('CALL_USER missing schedule_id', userData);
                return;
            }

            this.caller = userData.caller;
            this.recipient = Object.assign({}, userData.recipient, {
                channelid: String(scheduleId),
            });
            this.callReservation = userData.reservationData;

            console.log('CALL_USER for this member — showing invite', scheduleId);

            this.joinWithVideo = true;
            this.joinWithMic = true;

            this.$nextTick(() => {
                this.$bvModal.show('modal-call-alert');
            });

            this.playIncomingCallAudio({ path: 'mp3/incoming-call.mp3' }, 50);
            this.emitCallPingbackToTutor(userData.caller, scheduleId);
        },
        maximizeModal() {
            this.isModalMaximized = !this.isModalMaximized;
        },
        showCollapse(index) {
            for (var i = 0; i <= this.perPage; i++) {
                if (i == index) {
                    if (this.isCollapsed[index] == false) {
                        this.$set(this.isCollapsed, index, true)
                    } else {
                        this.$set(this.isCollapsed, index, false) //hide
                    }
                } else {
                    this.$set(this.isCollapsed, i, false) //hide
                }
            }
        },
        getLessonImages(index, folderID) {
            this.showCollapse(index)
            axios.post("/api/getLessonImages?api_token=" + this.api_token,
                {
                    method: "POST",
                    folderID: folderID,
                }).then(response => {

                    if (response.data.success == true) {
                        this.$set(this.folder_images, index, response.data.files)
                        this.$forceUpdate();

                    } else {

                    }
                });
        },
        clearFolderImages() {
            this.folder_images = [];
            for (var i = 0; i <= this.perPage; i++) {
                this.$set(this.isCollapsed, i, false);
            }
        },

        updateUserList: function (users) {
            this.users = users;
            this.$forceUpdate();
        },
playIncomingCallAudio(audioConfig, remainingPlays) {
    console.log("playing incoming call audio, remaining plays:", remainingPlays);

    // Prevent multiple loops
    if (this.isPlayingAudio) {
        console.log("already playing incoming call audio");
        return;
    }

    this.isPlayingAudio = true;
    let incomingCallAudio = document.getElementById('incomingCallAudio');

    if (!incomingCallAudio) return;

    // Start playing repeatedly
    const playLoop = () => {
        if (remainingPlays <= 0) {
            console.log("user busy, we called 50 times");
            this.stopIncomingCallAudio();
            return;
        }

        incomingCallAudio.src = window.location.origin + "/" + audioConfig.path;
        incomingCallAudio.load();
        incomingCallAudio.play();

        console.log("replaying IncomingCallAudio, remaining:", remainingPlays);
        remainingPlays--;
    };

    // Play every 3 seconds
    playLoop();
    this.incomingCallAudioInterval = setInterval(playLoop, 3000);
},

stopIncomingCallAudio() {
    console.log("stopping incoming call audio");
    clearInterval(this.incomingCallAudioInterval);
    this.isPlayingAudio = false;

    const audio = document.getElementById('incomingCallAudio');
    if (audio) {
        audio.pause();
        audio.currentTime = 0;
    }
},
        openSelfWindow(channelid) {
            window.location.href = window.location.origin + "/webRTC?roomid=" + channelid
        },
        openNewChannelTab(channelid) {
            var baseURL = window.location.origin + "/webRTC?roomid=" + channelid
            window.open(baseURL, '_blank');
        },
        emitCallPingbackToTutor(tutor, scheduleId) {
            const channelid = String(scheduleId || this.callReservation.schedule_id);
            const pingbackUser = Object.assign({}, this.user, {
                channelid: channelid,
                type: 'MEMBER',
            });

            this.socket.emit('CALL_USER_PINGBACK', pingbackUser);

            if (tutor && (tutor.userid || tutor.userId)) {
                this.socket.emit('CALL_USER_PINGBACK', Object.assign({}, pingbackUser, {
                    recipient: tutor,
                }));
            }
        },
        notifyTutorCallAccepted() {
            const tutor = this.caller;
            const channelid = String(this.callReservation.schedule_id);
            const callData = {
                tutorData: tutor,
                channelid: channelid,
                caller: this.user,
                recipient: tutor,
                reservationData: this.callReservation,
                callReservation: this.callReservation,
            };

            console.log('emit ACCEPT_CALL to tutor', tutor && tutor.userid);
            this.socket.emit('ACCEPT_CALL', callData);
            this.socket.emit('LESSON_CALL_ANSWERED', {
                channelid: channelid,
                member: this.user,
                tutor: tutor,
                reservationData: this.callReservation,
            });
            this.emitCallPingbackToTutor(tutor, channelid);
        },
        saveJoinMediaPreferences() {
            if (typeof window !== 'undefined' && window.sessionStorage) {
                window.sessionStorage.setItem('lesson_join_video', this.joinWithVideo ? '1' : '0');
                window.sessionStorage.setItem('lesson_join_mic', this.joinWithMic ? '1' : '0');
            }
        },
        toggleJoinVideo() {
            this.joinWithVideo = !this.joinWithVideo;
        },
        toggleJoinMic() {
            this.joinWithMic = !this.joinWithMic;
        },
        acceptCall() {
            this.sliderLoaded = false;
            this.channelid = this.callReservation.schedule_id;
            this.lessonReservationData = this.callReservation;

            this.stopIncomingCallAudio();
            this.saveJoinMediaPreferences();
            this.$bvModal.hide('modal-call-alert');
            this.$bvModal.hide('modal-call-teacher');
            this.$bvModal.hide('modal-call-member');

            this.notifyTutorCallAccepted();

            const sliderData = {
                channelid: this.channelid,
                caller: this.caller,
                recipient: this.recipient,
                reservationData: this.callReservation,
            };
            this.socket.emit('START_SLIDER', sliderData);

            this.openSelfWindow(this.channelid);
        },
        callMember(tutor, member, reservation) {

            this.now = new Moment().tz("Japan");
            this.currentTime = Moment(this.now).tz("Japan").format("YYYY-MM-DD HH:mm:ss");
            this.reservation = this.normalizeCallPayload(reservation);
            this.tutor = this.normalizeCallPayload(tutor);
            this.member = this.normalizeCallPayload(member);

            this.lessonStartTime = Moment(this.reservation.lesson_time).format('YYYY-MM-DD HH:mm:ss')
            this.lessonEndTime = Moment(this.reservation.lesson_time).add(this.reservation.duration, 'minutes').format('YYYY-MM-DD HH:mm:ss');


            //console.log(this.lessonStartTime)
            //console.log(this.lessonEndTime);
            //console.log(this.reservation)

            //search member
            let userIndex = this.users.findIndex(user => user.userid == this.member.userid)
            this.recipient = this.users[userIndex];

            if (typeof this.recipient == 'undefined') {
                alert("Sorry, Member is not online at the moment");
                return false
            } else {
                let response = this.checkTime();
                if (response.valid == true) {
                    this.$bvModal.show('modal-call-member');
                    //CALL USER (EMIT DATA)
                    let data = {
                        recipient: this.member,    //recipient 
                        caller: this.tutor,     //caller
                        reservationData: this.reservation
                    }
                    this.socket.emit('CALL_USER', data);
                }
            }
        },
        //CALL TUTOR IS INITIATED AT THE FRONT END USING JS (window.memberCallerComponent.callTutor) COMMAND
        normalizeCallPayload(value) {
            if (typeof value === 'string') {
                try {
                    return JSON.parse(value);
                } catch (error) {
                    return value;
                }
            }

            return value;
        },
        callTutor(tutor, member, reservation) {

            console.log("call tutor")

            this.reservation = this.normalizeCallPayload(reservation);
            this.tutor = this.normalizeCallPayload(tutor);
            this.member = this.normalizeCallPayload(member);

            this.channelid = this.reservation.schedule_id;

            this.lessonReservationData = this.reservation;

            this.now = new Moment().tz("Japan");
            this.currentTime = Moment(this.now).tz("Japan").format("YYYY-MM-DD HH:mm:ss");

            this.lessonStartTime = Moment(this.reservation.lesson_time).format('YYYY-MM-DD HH:mm:ss')
            this.lessonEndTime = Moment(this.reservation.lesson_time).add(this.reservation.duration, 'minutes').format('YYYY-MM-DD HH:mm:ss');


            let userIndex = this.users.findIndex(user => user.userid == this.tutor.userid);
            this.recipient = this.users[userIndex];



            if (typeof this.recipient == 'undefined') {

                alert("Sorry, teacher is not online at the moment");
                return false;

            } else {


                /** 
                **  
                **  [CHECK CURRENT TIME TO AVOID DUPLICATE CALLS]    
                ** 
                */
                let response = this.checkTime();

                if (response.valid == true) {

                    this.$bvModal.show('modal-call-teacher');

                    //CALL USER (EMIT DATA)
                    let data = {
                        caller: this.member,
                        recipient: this.tutor,   //recipient tutor 
                        reservationData: this.reservation
                    }

                    this.socket.emit('CALL_USER', data);

                }


            }
        },
        cancelCall() {
            this.$bvModal.hide('modal-call-alert');

            let data = {
                memberData: this.member,
                tutorData: this.tutor,
                reservationData: this.reservation
            }

            this.socket.emit('DROP_CALL', data);

        },
        checkTime() {
            var duration = Moment.duration(this.now.diff(this.lessonStartTime));
            var days = duration.asDays();

            //*** TEMPORARY VALID ALL TO TRUE */
            return ({ 'valid': true });


            if (this.currentTime >= this.lessonStartTime && this.currentTime <= this.lessonEndTime) {
                this.$bvModal.show('modal-call-teacher');

                return ({ 'valid': true })

            } else if (this.currentTime >= this.lessonEndTime) {



                alert("The Lesson has already ended" + this.currentTime + ">=  " + this.lessonEndTime);

                return ({ 'valid': false })

            } else {

                let numberOfDays = parseInt(days);

                if (numberOfDays == 0) {

                    alert("Your lesson will start on " + this.lessonStartTime + " Today");


                } else {

                    alert('Lesson will start after ' + Math.abs(numberOfDays) + ' days ');
                }



                return ({ 'valid': false })

            }

        },

        /****** START SEACH UI****  */
        openSearchUI() {
            this.isSearching = true;
        },
        closeSearchUI() {
            this.isSearching = false;
        },
        handleSearch() {
            const str = '' + this.searchTimeout + '';
            const trimmedStr = str.trim();
            const isEmpty = trimmedStr.length === 0;

            if (isEmpty) {
                //@todo: add empty message
            } else {
                clearTimeout(this.searchTimeout);
                // Start a new timeout to delay the search by half a second
                this.searchTimeout = setTimeout(this.search, 500);
            }
        },
        search() {
            console.log("searching...");

            axios.post("/api/searchFolders?api_token=" + this.api_token,
                {
                    method: "POST",
                    searchKeyword: this.searchKeyword,

                }).then(response => {

                    if (response.data.success == true) {

                        this.searchResults = response.data.folders;

                    } else {
                        //alert ("Error, we can't do a search on your keyword, please try again later")
                        this.searchResults = [];
                        this.$forceUpdate();
                    }
                });
        },

        /* Select Lesson */
        selectLesson(tutor, member, reservation) {
            //this.tutor              = JSON.parse(tutor);
            //this.member             = JSON.parse(member);
            //this.reservation        = JSON.parse(reservation);
            let myTutor = JSON.parse(tutor);
            this.myReservation = JSON.parse(reservation);
            this.currentMember = JSON.parse(member);
            this.getMemberSelectedLesson(this.myReservation, this.currentMember)
        },

        getMemberSelectedLesson(myReservation, currentMember) {
            axios.post("/api/getMemberLessonSelected?api_token=" + this.api_token,
                {
                    method: "POST",
                    userID: currentMember.userid,
                    lessonID: myReservation.schedule_id
                }).then(response => {

                    if (response.data.success == true) {
                        this.lessonSelectedFolderID = response.data.memberSelectedLesson.folder_id;
                        this.getLessonSelectedPreviewByID(myReservation, this.lessonSelectedFolderID)
                        this.$bvModal.show('modalSelectLesson');
                    } else {
                        this.$bvModal.show('modalSelectLesson');
                    }
                });
        },
        getLessonSelectedPreviewByID(myReservation, lessonSelectedFolderID) {
            axios.post("/api/getLessonSelectedPreview?api_token=" + this.api_token,
                {
                    method: "POST",
                    userID: myReservation.member_id,
                    lessonID: this.selectedLessonID,
                    lessonSelectedFolderID: lessonSelectedFolderID

                }).then(response => {

                    if (response.data.success == true) {

                        this.currentSelectedFolder = response.data.folder;

                        //determine the file
                        if (response.data.files.length == 0) {
                            this.currentSelectedFiles = null;
                            this.$forceUpdate();
                        } else {
                            this.currentSelectedFiles = response.data.files;
                            this.$forceUpdate();
                        }
                    } else {
                        //@note:  nullify files to null to make the notication appear
                        this.currentSelectedFiles = null;
                        this.folder = null;
                        this.$forceUpdate();
                    }
                });
        },
        openSlideSelector(lessonID, userID) {
            this.selectedLessonID = null;
            this.parentID = null;
            //MEMBER INFO
            this.lessonID = lessonID;
            this.userID = userID;
            this.$refs['slideSelectorModal'].show();
        },
        closeSlideSelector() {
            this.$refs['slideSelectorModal'].hide();
        },
        selectNewLesson(folderID) {
            this.lessonSelectedFolderID = folderID;
            this.saveOptionSelected(folderID);
        },
        saveOptionSelected(folderID) {

            axios.post("/api/saveSelectedLessonSlideMaterial?api_token=" + this.api_token,
                {
                    method: "POST",
                    userID: this.currentMember.userid,
                    lessonID: this.myReservation.schedule_id,
                    folderID: folderID,

                }).then(response => {

                    if (response.data.success == true) {
                        this.hasSelected = true;

                        setTimeout(() => {
                            this.$bvModal.hide('modalSelectLesson');
                        }, 3000);

                    } else {
                        alert(response.data.message);
                    }
                });

        },
        selectCategory(id) {
            this.isSearching = false;
            if (id == 0) {
                this.selectedLessonID = null;
            } else {
                this.selectedLessonID = id;
            }
            this.getLessonsList();
        },
        openPage(num) {
            axios.post("/api/getLessonList?api_token=" + this.api_token,
                {
                    method: "POST",
                    folderID: this.selectedLessonID,
                    //public_folder_id : null,
                }).then(response => {
                    if (response.data.success == true) {
                        this.lessons = response.data.lessons.data;
                    } else {
                        alert("Error, we can't get your list of lesson, please try again later")
                    }
                });
        },
        getLessonsList() {

            this.hasSelected = false;

            axios.post("/api/getLessonFolders?api_token=" + this.api_token,
                {
                    method: "POST",
                    folderID: this.selectedLessonID,
                    //public_folder_id : null,
                }).then(response => {

                    if (response.data.success == true) {

                        this.parentID = response.data.parentID;
                        this.currentFolder = response.data.currentFolder;
                        this.folderCategories = response.data.folderCategories;
                        this.lessons = response.data.lessons;
                        this.rows = response.data.lesson_rows;
                        this.files = response.data.files;

                        //this.lessons            = response.data.lessons.data; (lazy loading)

                        this.$forceUpdate();
                    } else {
                        alert("Error, we can't get your list of lesson, please try again later")
                    }
                });
        },
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        },
        getBaseURL(path) {
            return window.location.origin + "/" + path
        },
        imageViewer(imageURL) {
            this.imageURL = imageURL;
            this.$bvModal.show('modalImageViewer');
        },
        toggleDetails(row) {
            return row;
        }
    }
};
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}

.card-body-minimum {
    min-height: 100px;
}
</style>

<style>
.no-padding td {
    padding: 0;
}


#modal-call-alert .modal-header {
    padding: 0px;
    margin: 0px;
}

.modal-header h5 {
  margin: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.modal-header-custom {
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-mypage-logo {
    width: 133px;  
    position: relative;
    left: 20px;
}

.incoming-call-media-controls .btn {
    min-width: 130px;
}


</style>